<template>
  <div class="page-container">
    <header-title
      title="Lost Hour by Region/Andon Category"
      @onRefresh="onLoad"
      has-refresh
    ></header-title>
    <div class="filter-box">
      <a-form layout="inline" :model="form" @finish="onLoad">
        <a-form-item>
          <a-select v-model:value="form.type" @change="typeChange">
            <a-select-option
              v-for="item in typeList"
              :key="item.value"
              :value="item.value"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
      <a-button class="alin-right" type="link" @click="goVaratio">
        <template #icon><bar-chart-outlined /></template>
        VA Ratio
      </a-button>
    </div>
    <div class="page-body">
      <a-row v-if="pic.series && pic.series.length && dataSource.length">
        <a-col :span="12">
          <pic-chart
            :pic-charts-series="pic.series"
            :pic-charts-title="pic.title"
          ></pic-chart>
        </a-col>
        <a-col :span="12">
          <div class="table-box" ref="aTableRef">
            <a-table
              :loading="loading"
              size="small"
              :dataSource="dataSource"
              :columns="columns"
              rowKey="id"
              :pagination="false"
              :row-class-name="
                (record, index) => (index % 2 === 1 ? 'table-striped' : null)
              "
              :scroll="scroll"
            />
          </div>
        </a-col>
      </a-row>
      <div v-else style="margin-top: 100px">
        <a-empty />
      </div>
    </div>
  </div>
</template>
<script>
  import HeaderTitle from '@/layout/header-title'
  import { BarChartOutlined } from '@ant-design/icons-vue'
  import { getUtilization } from '@/api/supervisor-landing'
  import { throttle } from '@/utils'
  import PicChart from './pic-chart'
  export default {
    components: { HeaderTitle, BarChartOutlined, PicChart },
    data() {
      return {
        loading: false,
        form: {
          type: 1,
        },
        typeList: [
          { name: 'By Andon Category', value: 1 },
          { name: 'By Region', value: 2 },
        ],
        pic: {},
        scroll: { y: 300 },
        dataSource: [],
        columns: [
          {
            title: 'No',
            dataIndex: 'no',
            customRender({ index }) {
              return index + 1
            },
            width: '10%',
          },
          {
            title: 'Andon Category',
            dataIndex: 'name',
            width: '30%',
          },
          {
            title: 'Line Stop From',
            dataIndex: 'starting',
            width: '30%',
          },
          {
            title: 'Lost Hour',
            dataIndex: 'lostTime',
            width: '30%',
          },
        ],
      }
    },

    created() {
      this.onLoad()
    },
    mounted() {
      this.setTableScrollH()
      window.addEventListener('resize', throttle(this.setTableScrollH, 500))
    },
    methods: {
      typeChange(v) {
        this.columns[1].title = v === 1 ? 'Andon Category' : 'Region Name'
        this.onLoad()
      },
      setTableScrollH() {
        let top = 88
        if (this.$refs.aTableRef) {
          top = this.$refs.aTableRef.getBoundingClientRect().top
        }
        const wH = window.innerHeight
        this.scroll = { y: wH - (top + 70) }
      },
      async onLoad() {
        this.loading = true
        const { id, uiid } = this.$route.query
        const params = {
          id,
          uiid,
        }

        try {
          const { body } = await getUtilization(params)

          this.dataSource = this.form.type === 1 ? body.category : body.region
          this.pic = {
            title: this.form.type === 1 ? 'By Andon Category' : 'By Region',
            series: this.getLostHourTotal(this.dataSource),
          }

          this.loading = false
        } catch (e) {
          this.loading = false
        }
      },
      getLostHourTotal(items) {
        let result = [],
          hash = {}
        if (!items) return
        for (var i = 0, elem = items; i < elem.length; i++) {
          if (!hash[elem[i].name]) {
            result.push({ name: elem[i].name, value: 0 })
            hash[elem[i].name] = 1
          }
        }
        for (let i = 0; i < result.length; i++) {
          for (var j = 0; j < items.length; j++) {
            if (result[i].name == items[j].name) {
              result[i].value += items[j].lostTime
            }
          }
          result[i].value = Math.round(result[i].value * 100) / 100
        }
        return result
      },
      goVaratio() {
        const { id, uiid } = this.$route.query
        this.$router.push({ path: '/va-ratio', query: { id, uiid } })
      },
    },
  }
</script>
<style lang="less" scoped>
  .page-container {
    height: calc(100vh - 32px);
    :deep(.ant-select) {
      width: 200px;
    }
    .page-body {
      height: calc(100vh - 130px);
      overflow: auto;
      padding: 15px;
    }
    .table-box {
      margin: 10px;
      border: 1px solid #e1e1e1;
    }
    :deep(.ant-table-tbody) {
      .table-striped td {
        background-color: #fbfbfb;
      }
    }
  }
</style>
